import * as devConf from './config.dev';
import * as prodConf from './config.prod';

const isProd = process.env.CONFIG_ENV === 'production';

console.table(process.env);

export default isProd ? prodConf : devConf;



// WEBPACK FOOTER //
// ./src/config/index.js